import { createAction } from '@reduxjs/toolkit';
import { RoutesType } from './types';

export const routeChangeAction = createAction<string>('routeChange');
export const navigateTo = createAction<keyof RoutesType>('navigation/navigateTo');
